import i18n from "i18next"
import detector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

import ru from "./locales/ru.json"
import uz from "./locales/uz.json"
import en from "./locales/en.json"
import tr from "./locales/tr.json"

// the translations
const resources = {
	"RU": {
		translation: ru,
	},
	"UZ": {
		translation: uz,
	},
	"EN": {
		translation: en,
	},
	"TR": {
		translation: tr,
	},
}

const language = localStorage.getItem("language")
if (!language) {
	localStorage.setItem("language", "RU")
}

i18n
	.use(detector)
	.use(initReactI18next) // passes i18n down to react-i18next
	.init({
		resources,
		lng: localStorage.getItem("language") || "RU",
		fallbackLng: "RU", // use en if detected lng is not available

		keySeparator: false, // we do not use keys in form messages.welcome

		interpolation: {
			escapeValue: false, // react already safes from xss
		},
	})

export default i18n
